<template>
  <div>
    <el-form size="mini" ref="form" label-position="left" label-width="170px" v-loading="loading" element-loading-spinner="nucleus-loader">
      <el-row :gutter="30">
        <el-col :span="12">
          <h4 class="headerWithBorder">Chart Demographic</h4>

          <el-form-item size="mini" label="Patient Number">
            <a v-if="documentManagerAdmin() && recordId && !readOnly" style="margin: 6px 0px 0px 0px; float: left;" :href="`${compParticleBaseUrl}/reviews/inpatient/${recordId}`" target="_new">{{ worksheet.patacctnum }}</a>
            <el-input v-else disabled size="mini" :maxlength="15" type="text" id="patAcctNum" v-model="worksheet.patacctnum"> </el-input>
          </el-form-item>

          <el-form-item size="mini" label="MR Number">
            <el-input :disabled="disabled" size="mini" :maxlength="15" type="text" id="mrNumber" v-model="worksheet.mrnumber"> </el-input>
          </el-form-item>

          <el-form-item size="mini" label="Payor">
            <el-input :disabled="disabled" v-model="worksheet.payorName" placeholder="Payor" itemkey="key" label="value"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Payor Detail">
            <el-input :disabled="disabled" v-model="worksheet.payorDetail" placeholder="Payor Detail" itemkey="key" label="value"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Discharge Date">
            <el-date-picker :disabled="disabled" size="mini" type="date" id="dischargeDate" v-model="worksheet.dischargeDate" format="MM/dd/yyyy"> </el-date-picker>
          </el-form-item>

          <el-form-item size="mini" label="IP Admit Date">
            <el-date-picker :disabled="disabled" size="mini" type="date" id="admitDate" v-model="worksheet.admitDate" format="MM/dd/yyyy"></el-date-picker>
          </el-form-item>

          <el-form-item size="mini" label="Age">
            <el-input disabled v-model="worksheet.patientAge"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Patient Sex">
            <el-input disabled v-model="worksheet.sex"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Length of Stay">
            <el-input disabled v-model="worksheet.los"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <h4 class="headerWithBorder">Review Information</h4>

          <el-form-item size="mini" label="Facility">
            <el-input disabled v-model="worksheet.clientName"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Auditor">
            <el-input disabled v-model="worksheet.reviewer"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Review Date">
            <el-date-picker disabled size="mini" type="date" id="revDate" v-model="worksheet.reviewDate" format="MM/dd/yyyy"> </el-date-picker>
          </el-form-item>

          <el-form-item size="mini" label="Coder">
            <el-input disabled v-model="worksheet.coder"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="D/C Summ. Avail at Coding">
            <el-input disabled v-model="worksheet.dcSummAvailAtCoding"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="UB Available">
            <el-input disabled :value="worksheet.noUBAvailable ? 'No' : 'Yes'"></el-input>
            <!-- {{worksheet.noUBAvailable ? 'No' : 'Yes'}} -->
          </el-form-item>

          <el-form-item size="mini" label="Physician">
            <el-input disabled v-model="worksheet.physician"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Reason for Change">
            <el-input disabled v-model="worksheet.reasonForChangeDesc"></el-input>
          </el-form-item>

          <!-- <el-form-item size="mini" label="Audit Result">
            <el-input disabled v-model="worksheet.auditResult"></el-input>
          </el-form-item> -->
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :xl="8" :sm="12" class="top-margin">
          <h4 class="headerWithBorder">Original Coding Details</h4>

          <el-form-item size="mini" :label="`${worksheet.ipReviewType}`">
            <el-input disabled size="mini" id="originalDrg" v-model="worksheet.orDRG"> </el-input>
          </el-form-item>

          <el-form-item size="mini" label="DRG Description">
            <div class="lineclamp" :title="worksheet.orDRGDescription">{{ worksheet.orDRGDescription }}</div>
          </el-form-item>

          <el-form-item size="mini" :label="`${worksheet.ipReviewType} Weight`">
            <el-input :disabled="disabled" size="mini" id="originalWeight" v-model="worksheet.orWt"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Patient Status">
            <el-input disabled v-model="worksheet.orPatStat"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Point of Origin">
            <el-input disabled v-model="worksheet.originalPOO"></el-input>
          </el-form-item>

          <el-form-item v-if="worksheet.otherDRGType" size="mini" :label="`${worksheet.otherDRGType}`">
            <el-input disabled size="mini" id="otherDRGType" v-model="worksheet.displayOtherOrDrg"> </el-input>
          </el-form-item>

          <el-form-item v-if="worksheet.otherDRGType" size="mini" label="DRG Description">
            <div class="lineclamp" :title="worksheet.orDRGDescription">{{ worksheet.orAPRDRGDescription }}</div>
          </el-form-item>

          <el-form-item v-if="worksheet.originalSOI" size="mini" label="SOI">
            <el-input disabled size="mini" id="originalSOI" v-model="worksheet.originalSOI"> </el-input>
          </el-form-item>

          <el-form-item v-if="worksheet.originalROM" size="mini" label="ROM">
            <el-input disabled size="mini" id="originalROM" v-model="worksheet.originalROM"> </el-input>
          </el-form-item>

          <el-form-item v-if="worksheet.psis.filter(f => f.reviewLevel === 0).length" size="mini" label="Original PSIs">
            <span style="display: block" v-for="item in worksheet.psis.filter(f => f.reviewLevel === 0)" :title="item.shortDescription" :key="item.shortDescription"
              ><a :href="item.href" target="_blank"><i class="mdi mdi-alert" style="color: #f56c6c"></i> {{ item.shortDescription }}</a></span
            >
          </el-form-item>

          <el-form-item v-if="worksheet.qualityMeasures.filter(f => f.reviewLevel === 0).length" size="mini" label="Original QMs">
            <el-popover placement="bottom" title="CMS.gov QualityNet" width="360" trigger="click">
              <a href="https://www.qualitynet.org/inpatient/measures/mortality/methodology" target="_blank">
                <el-button size="mini" type="primary">Mortality Methodology</el-button>
              </a>
              <a style="margin-left: 10px" href="https://www.qualitynet.org/inpatient/measures/readmission/methodology" target="_blank">
                <el-button size="mini" type="primary">Readmission Methodology</el-button>
              </a>
              <span slot="reference" style="display: block; cursor: pointer; color: #337ab7; margin-top: 4px;" v-for="item in worksheet.qualityMeasures.filter(f => f.reviewLevel === 0)" :title="`${item.identifier}`" :key="item.identifier"><i class="mdi mdi-alert" style="color: #f56c6c"></i> {{ item.identifier }}</span>
            </el-popover>
          </el-form-item>
        </el-col>

        <el-col :xl="8" :sm="12" class="top-margin">
          <h4 class="headerWithBorder">Coding Audit Determinations</h4>
          <el-form-item size="mini" :label="`Recommended ${worksheet.ipReviewType}`">
            <el-input disabled size="mini" id="originalDrg" v-model="worksheet.recDRG">
              <el-button v-if="worksheet.recDRG && !(readOnly && embedded)" slot="suffix" style="margin: -2px 5px 0px 0px;" size="mini" type="text" @click="SET_RESPONSE_DRG({ originalDrg: worksheet.orDRG, recommendedDrg: worksheet.recDRG })" :disabled="readOnly">Respond </el-button>
            </el-input>
          </el-form-item>

          <el-form-item size="mini" label="DRG Description">
            <div class="lineclamp" :title="worksheet.recDRGDescription">{{ worksheet.recDRGDescription }}</div>
          </el-form-item>

          <el-form-item size="mini" :label="`${worksheet.ipReviewType} Rec. Weight`">
            <el-input :disabled="disabled" size="mini" id="originalWeight" v-model="worksheet.recWt"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Rec. Patient Status">
            <el-input disabled v-model="worksheet.recPatstat">
              <el-button v-if="worksheet.recPatstat && !(readOnly && embedded)" slot="suffix" style="margin: -2px 5px 0px 0px;" size="mini" type="text" @click="SET_RESPONSE_PATSTAT({ originalPatStat: worksheet.orPatStat, recommendedPatStat: worksheet.recPatstat })" :disabled="readOnly">Respond </el-button>
            </el-input>
          </el-form-item>

          <el-form-item size="mini" label="Rec. Point of Origin">
            <el-input disabled v-model="worksheet.recommendedPOO">
              <el-button v-if="worksheet.recommendedPOO && !(readOnly && embedded)" slot="suffix" style="margin: -2px 5px 0px 0px;" size="mini" type="text" @click="SET_RESPONSE_POO({ originalPoo: worksheet.originalPOO, recommendedPoo: worksheet.recommendedPOO })" :disabled="readOnly">Respond </el-button>
            </el-input>
          </el-form-item>

          <el-form-item v-if="worksheet.otherDRGType" size="mini" :label="`${worksheet.otherDRGType}`">
            <el-input disabled size="mini" id="otherDRGType" v-model="worksheet.displayOtherlvl1Drg"> </el-input>
          </el-form-item>

          <el-form-item v-if="worksheet.otherDRGType" size="mini" label="DRG Description">
            <div class="lineclamp" :title="worksheet.orDRGDescription">{{ worksheet.recAPRDRGDescription }}</div>
          </el-form-item>

          <el-form-item v-if="worksheet.originalSOI" size="mini" label="SOI">
            <el-input disabled size="mini" id="originalSOI" v-model="worksheet.recommendedSOI"> </el-input>
          </el-form-item>

          <el-form-item v-if="worksheet.originalROM" size="mini" label="ROM">
            <el-input disabled size="mini" id="originalROM" v-model="worksheet.recommendedROM"> </el-input>
          </el-form-item>

          <el-form-item v-if="worksheet.psis.filter(f => f.reviewLevel === 1).length" size="mini" label="Rec. PSIs">
            <span style="display: block" v-for="item in worksheet.psis.filter(f => f.reviewLevel === 1)" :title="item.shortDescription" :key="item.shortDescription"
              ><a :href="item.href" target="_blank"><i class="mdi mdi-alert" style="color: #f56c6c"></i> {{ item.shortDescription }}</a></span
            >
          </el-form-item>

          <el-form-item v-if="worksheet.qualityMeasures.filter(f => f.reviewLevel === 1).length" size="mini" label="Rec. QMs">
            <el-popover placement="bottom" title="CMS.gov QualityNet" width="360" trigger="click">
              <a href="https://www.qualitynet.org/inpatient/measures/mortality/methodology" target="_blank">
                <el-button size="mini" type="primary">Mortality Methodology</el-button>
              </a>
              <a style="margin-left: 10px" href="https://www.qualitynet.org/inpatient/measures/readmission/methodology" target="_blank">
                <el-button size="mini" type="primary">Readmission Methodology</el-button>
              </a>
              <span slot="reference" style="display: block; cursor: pointer; color: #337ab7; margin-top: 4px;" v-for="item in worksheet.qualityMeasures.filter(f => f.reviewLevel === 1)" :title="`${item.identifier}`" :key="item.identifier"><i class="mdi mdi-alert" style="color: #f56c6c"></i> {{ item.identifier }}</span>
            </el-popover>
          </el-form-item>
        </el-col>

        <el-col :xl="8" :sm="12" class="top-margin">
          <h4 class="headerWithBorder">Query Analysis</h4>

          <el-form-item size="mini" label="CDI Query Missed">
            <el-input disabled :value="worksheet.cdiQueryMissed ? 'Yes' : 'No'"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="CDI Query">
            <el-input disabled :value="worksheet.cdiQuery ? 'Yes' : 'No'"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Coder Query">
            <el-input disabled :value="worksheet.coderQuery ? 'Yes' : 'No'"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Coder Query Missed">
            <el-input disabled :value="worksheet.coderQueryMissed ? 'Yes' : 'No'"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Reviewer Query">
            <el-input disabled :value="worksheet.auditQuery ? 'Yes' : 'No'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import dateHelper from '@/mixins/date-helper'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import { format, parseISO } from 'date-fns'
import { mapMutations } from 'vuex'

export default {
  name: 'coderInpatientDemographics',
  mixins: [dateHelper, HiaAuthorization],
  props: {
    worksheet: { type: Object, required: true },
    readOnly: { type: Boolean, default: false },
    embedded: { type: Boolean, default: false }
  },
  data() {
    return {
      format: format,
      parseISO: parseISO,
      disabled: true,
      loading: false
    }
  },
  methods: {
    ...mapMutations('myProjects/', ['SET_RESPONSE_PATSTAT', 'SET_RESPONSE_DRG', 'SET_RESPONSE_POO'])
  },
  computed: {
    compParticleBaseUrl() {
      return process.env.VUE_APP_PARTICLE_BASE_URL
    },
    recordId() {
      return this.$route.params.drgTableId || this.worksheet.drgTableID
    }
    // ...mapState('profile/', ['userProfile'])
  }
}
</script>

<style scoped>
.lineclamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 38px;
  max-height: 38px;
  text-overflow: ellipsis;
  background-color: #eaeaea;
  border-radius: 5px;
  padding: 5px 15px 5px 15px;
}
</style>
